var map = {
	"./add-circle.svg": 1056,
	"./agenda.svg": 1057,
	"./brewery.svg": 1058,
	"./burger.svg": 1059,
	"./cat-lost.svg": 1060,
	"./check-circle.svg": 1061,
	"./chef-hat.svg": 1062,
	"./chevron-left.svg": 1063,
	"./close.svg": 1064,
	"./cogs.svg": 1065,
	"./cube.svg": 1066,
	"./customers.svg": 1067,
	"./delete-circle.svg": 1068,
	"./download-circle.svg": 1069,
	"./home.svg": 1070,
	"./ingredients.svg": 1071,
	"./keg.svg": 1072,
	"./lab-tube-bottle.svg": 1073,
	"./man-astronaut.svg": 1074,
	"./money-bag-dollar.svg": 1075,
	"./navigation-menu-horizontal.svg": 1076,
	"./navigation-menu-vertical.svg": 1077,
	"./orders.svg": 1078,
	"./plant.svg": 1079,
	"./question-circle.svg": 1080,
	"./reports.svg": 1081,
	"./shelf.svg": 1082,
	"./shipment-in-transit.svg": 1083,
	"./skull.svg": 1084,
	"./sparkle.svg": 1085,
	"./stove-pot.svg": 1086,
	"./tank.svg": 1087,
	"./transfer.svg": 1088,
	"./wine-barrel.svg": 1089
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1055;


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs \.(svg)$
// module id = 1055
// module chunks = 0